class CustomProductForm extends HTMLElement {
    constructor() {
        super();
        this.form = null;
    }

    connectedCallback() {
        this.form = this.querySelector('form');
        if (this.form) {
            this.form.addEventListener('submit', this.onHandleSubmit.bind(this));
        }
        this.idInput = document.querySelector('input[name="id"]');
        this.quantityInput = document.querySelector('input[name="quantity"]');
        this.frontIncColorInput = document.querySelector('[name="front-ink"]');
        this.backIncColorInput = document.querySelector('[name="back-ink"]');
        this.pocketIncColorInput = document.querySelector('[name="pocket-ink"]');
    }

    onHandleSubmit(event) {
        event.preventDefault();

        const formData = new FormData(this.form);
        const submitButton = this.form.querySelector('[type="submit"]');

        if (submitButton) {
            submitButton.disabled = true;
            submitButton.setAttribute('aria-disabled', true);
        }
        const uniqueId = this.generateUniqueId();

        const items = [];
        const parentId = Number(this.idInput.value)
        const quantity = Number(this.quantityInput.value)

        items.push({
            id: parentId,
            quantity: quantity,
            properties: {
                "_stitching_id": uniqueId
            }
        })

        if (this.frontIncColorInput) {
            const frontSelectedOption = this.frontIncColorInput.selectedOptions[0]

            if (frontSelectedOption.getAttribute('data-additional-color-price-variant-id')) {
                items.push({
                    id: Number(frontSelectedOption.getAttribute('data-additional-color-price-variant-id')),
                    quantity: quantity,
                    parent_id: parentId,
                    properties: {
                        "_stitching_id": uniqueId,
                        "_is_color_setup": true
                    }
                })
            }

            items.push({
                id: Number(frontSelectedOption.getAttribute('data-additional-color-fee-variant-id')),
                parent_id: parentId,
                properties: {
                    "_stitching_id": uniqueId
                }
            })
        }

        if (this.backIncColorInput) {
            const backSelectedOption = this.backIncColorInput.selectedOptions[0]

            if (backSelectedOption.getAttribute('data-additional-color-price-variant-id')) {
                items.push({
                    id: backSelectedOption.getAttribute('data-additional-color-price-variant-id'),
                    quantity: quantity,
                    parent_id: parentId,
                    properties: {
                        "_stitching_id": uniqueId,
                        "_is_color_setup": true
                    }
                })
            }

            if (backSelectedOption.getAttribute('data-additional-color-fee-variant-id')) {
                items.push({
                    id: Number(backSelectedOption.getAttribute('data-additional-color-fee-variant-id')),
                    parent_id: parentId,
                    properties: {
                        "_stitching_id": uniqueId
                    }
                })
            }
        }
        if (this.pocketIncColorInput) {
            const pocketSelectedOption = this.pocketIncColorInput.selectedOptions[0];

            if (pocketSelectedOption.getAttribute('data-additional-color-price-variant-id')) {
                items.push({
                    id: Number(pocketSelectedOption.getAttribute('data-additional-color-price-variant-id')),
                    quantity: quantity,
                    parent_id: parentId,
                    properties: {
                        "_stitching_id": uniqueId,
                        "_is_color_setup": true
                    }
                });
            }

            if (pocketSelectedOption.getAttribute('data-additional-color-fee-variant-id')) {
                items.push({
                    id: Number(pocketSelectedOption.getAttribute('data-additional-color-fee-variant-id')),
                    parent_id: parentId,
                    properties: {
                        "_stitching_id": uniqueId
                    }
                });
            }
        }

        fetch(window.routes.cart_add_url, {
            method: 'POST',
            body: JSON.stringify({items: items}),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok');
        })
        .then(data => {
            // Успешная отправка формы
            this.onSubmitSuccess(data);
        })
        .catch(error => {
            this.onSubmitError(error);
        })
        .finally(() => {
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.removeAttribute('aria-disabled');
            }
        });
    }

    onSubmitSuccess(data) {
        window.location.href = window.routes.cart_url;
    }

    generateUniqueId() {
        const timestamp = Date.now();
        const id = Math.random().toString(36).substr(2, 8);
        return `bag-combo-${timestamp}-${id}`;
    }

    onSubmitError(error) {
    }
}

if (!customElements.get('custom-product-form')) {
    customElements.define('custom-product-form', CustomProductForm);
}